import * as React from 'react';
import { FC, PropsWithChildren, useState } from 'react';
import { SnackbarContext } from './snackbar-context';
import { Snackbar } from './snackbar';
import { ISnackbarData } from './types';

export const SnackbarHandler: FC<PropsWithChildren> = ({ children }) => {

    const [snackbarNotifications, setSnackbarNotifications] = useState<ISnackbarData[]>([]);

    const [publishSnackbarNotification] = useState(() =>
        (newSnackbarNotification: ISnackbarData) => setSnackbarNotifications(currentSnackbarNotifications => [...currentSnackbarNotifications, newSnackbarNotification])
    );

    const [deleteSnackbarNotification] = useState(() =>
        (snackbarNotificationToDelete: ISnackbarData) => setSnackbarNotifications(currentSnackbarNotifications => currentSnackbarNotifications.filter(n => n !== snackbarNotificationToDelete))
    );

    const clearSnackbarNotifications = () => {
        setSnackbarNotifications([]);
    };

    return (
        <SnackbarContext.Provider value={publishSnackbarNotification}>
            {children}
            <Snackbar snackbarNotifications={snackbarNotifications}
                      handleDeleteSnackbarNotification={deleteSnackbarNotification}
                      handleClearSnackbarNotifications={clearSnackbarNotifications} />
        </SnackbarContext.Provider>
    );
};
